import { render, staticRenderFns } from "./ListUniformRequestForm.vue?vue&type=template&id=ccd442e6&scoped=true"
import script from "./ListUniformRequestForm.vue?vue&type=script&lang=js"
export * from "./ListUniformRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd442e6",
  null
  
)

export default component.exports